











import { Component, Vue, Prop } from 'vue-property-decorator';
import { LicenseDto } from '@/shared/dtos/agents-admin';
import GenericTable from '@/components/agents-admin/common/GenericTable.vue';

@Component({
    components: { GenericTable }
})
export default class LicensesTab extends Vue {
    @Prop() public licenses: LicenseDto[] = [];
    @Prop() public loading: boolean = false;

    public headers = [
        { text: 'ID', value: 'license_id', sortable: true },
        { text: 'Agente', value: 'agent_id', sortable: true },
        { text: 'Estado', value: 'status', sortable: true },
        { text: 'Expiración', value: 'expiration_date', sortable: true },
        { text: 'Instalaciones', value: 'current_installations', sortable: true }
    ];
}
